module.exports = __webpack_public_path__ + "images/_/programs/epsPrimaries/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/images/characters/ian_sara_lean_questioning.png
// module id = 202
// module chunks = 2